module.exports = __webpack_public_path__ + "img/h5_detail.4d2c3f2f.png";